module.exports = __webpack_public_path__ + "media/Pill-MissingFields.2f21b0c3.mp4";